webpackJsonp([173894859265406,224418557136868],{

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(18);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(90));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(133));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(71));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(70));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(211));
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends2.default)({}, props);
	
	  if (convertedProps.resolutions) {
	    convertedProps.fixed = convertedProps.resolutions;
	    delete convertedProps.resolutions;
	  }
	
	  if (convertedProps.sizes) {
	    convertedProps.fluid = convertedProps.sizes;
	    delete convertedProps.sizes;
	  }
	
	  return convertedProps;
	}; // Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	
	
	var imageCache = {};
	
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props); // Find src
	
	  var src = convertedProps.fluid ? convertedProps.fluid.src : convertedProps.fixed.src;
	  return imageCache[src] || false;
	};
	
	var activateCacheForImage = function activateCacheForImage(props) {
	  var convertedProps = convertProps(props); // Find src
	
	  var src = convertedProps.fluid ? convertedProps.fluid.src : convertedProps.fixed.src;
	  imageCache[src] = true;
	};
	
	var io;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, {
	      rootMargin: "200px"
	    });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var srcSetWebp = props.srcSetWebp ? "<source type='image/webp' srcSet=\"" + props.srcSetWebp + "\" " + sizes + "/>" : "";
	  var srcSet = props.srcSet ? "<source srcSet=\"" + props.srcSet + "\" " + sizes + "/>" : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	  return "<picture>" + srcSetWebp + srcSet + "<img " + width + height + src + alt + title + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/></picture>";
	};
	
	var Img = _react.default.forwardRef(function (props, ref) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      onError = props.onError,
	      otherProps = (0, _objectWithoutPropertiesLoose2.default)(props, ["style", "onLoad", "onError"]);
	  return _react.default.createElement("img", (0, _extends2.default)({}, otherProps, {
	    onLoad: onLoad,
	    onError: onError,
	    ref: ref,
	    style: (0, _extends2.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	});
	
	Img.propTypes = {
	  style: _propTypes.default.object,
	  onError: _propTypes.default.func,
	  onLoad: _propTypes.default.func
	};
	
	var Image =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Image, _React$Component);
	
	  function Image(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this; // default settings for browser without Intersection Observer available
	
	    var isVisible = true;
	    var imgLoaded = false;
	    var IOSupported = false;
	    var fadeIn = props.fadeIn; // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	
	    var seenBefore = inImageCache(props); // browser with Intersection Observer available
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      IOSupported = true;
	    } // Never render image during SSR
	
	
	    if (typeof window === "undefined") {
	      isVisible = false;
	    } // Force render for critical images
	
	
	    if (props.critical) {
	      isVisible = true;
	      IOSupported = false;
	    }
	
	    var hasNoScript = !(_this.props.critical && !_this.props.fadeIn);
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported,
	      fadeIn: fadeIn,
	      hasNoScript: hasNoScript,
	      seenBefore: seenBefore
	    };
	    _this.imageRef = _react.default.createRef();
	    _this.handleImageLoaded = _this.handleImageLoaded.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    _this.handleRef = _this.handleRef.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	    return _this;
	  }
	
	  var _proto = Image.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    if (this.state.isVisible && typeof this.props.onStartLoad === "function") {
	      this.props.onStartLoad({
	        wasCached: inImageCache(this.props)
	      });
	    }
	
	    if (this.props.critical) {
	      var img = this.imageRef.current;
	
	      if (img && img.complete) {
	        this.handleImageLoaded();
	      }
	    }
	  };
	
	  _proto.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        if (!_this2.state.isVisible && typeof _this2.props.onStartLoad === "function") {
	          _this2.props.onStartLoad({
	            wasCached: inImageCache(_this2.props)
	          });
	        }
	
	        _this2.setState({
	          isVisible: true,
	          imgLoaded: false
	        });
	      });
	    }
	  };
	
	  _proto.handleImageLoaded = function handleImageLoaded() {
	    activateCacheForImage(this.props);
	    this.setState({
	      imgLoaded: true
	    });
	
	    if (this.state.seenBefore) {
	      this.setState({
	        fadeIn: false
	      });
	    }
	
	    this.props.onLoad && this.props.onLoad();
	  };
	
	  _proto.render = function render() {
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === void 0 ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === void 0 ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === void 0 ? {} : _convertProps$placeho,
	        placeholderClassName = _convertProps.placeholderClassName,
	        fluid = _convertProps.fluid,
	        fixed = _convertProps.fixed,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = typeof backgroundColor === "boolean" ? "lightgray" : backgroundColor;
	    var imagePlaceholderStyle = (0, _extends2.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transition: "opacity 0.5s",
	      transitionDelay: this.state.imgLoaded ? "0.5s" : "0.25s"
	    }, imgStyle, placeholderStyle);
	    var imageStyle = (0, _extends2.default)({
	      opacity: this.state.imgLoaded || this.state.fadeIn === false ? 1 : 0,
	      transition: this.state.fadeIn === true ? "opacity 0.5s" : "none"
	    }, imgStyle);
	    var placeholderImageProps = {
	      title: title,
	      alt: !this.state.isVisible ? alt : "",
	      style: imagePlaceholderStyle,
	      className: placeholderClassName
	    };
	
	    if (fluid) {
	      var image = fluid;
	      return _react.default.createElement(Tag, {
	        className: (className ? className : "") + " gatsby-image-wrapper",
	        style: (0, _extends2.default)({
	          position: "relative",
	          overflow: "hidden"
	        }, style),
	        ref: this.handleRef,
	        key: "fluid-" + JSON.stringify(image.srcSet)
	      }, _react.default.createElement(Tag, {
	        style: {
	          width: "100%",
	          paddingBottom: 100 / image.aspectRatio + "%"
	        }
	      }), image.base64 && _react.default.createElement(Img, (0, _extends2.default)({
	        src: image.base64
	      }, placeholderImageProps)), image.tracedSVG && _react.default.createElement(Img, (0, _extends2.default)({
	        src: image.tracedSVG
	      }, placeholderImageProps)), bgColor && _react.default.createElement(Tag, {
	        title: title,
	        style: {
	          backgroundColor: bgColor,
	          position: "absolute",
	          top: 0,
	          bottom: 0,
	          opacity: !this.state.imgLoaded ? 1 : 0,
	          transitionDelay: "0.35s",
	          right: 0,
	          left: 0
	        }
	      }), this.state.isVisible && _react.default.createElement("picture", null, image.srcSetWebp && _react.default.createElement("source", {
	        type: "image/webp",
	        srcSet: image.srcSetWebp,
	        sizes: image.sizes
	      }), _react.default.createElement("source", {
	        srcSet: image.srcSet,
	        sizes: image.sizes
	      }), _react.default.createElement(Img, {
	        alt: alt,
	        title: title,
	        src: image.src,
	        style: imageStyle,
	        ref: this.imageRef,
	        onLoad: this.handleImageLoaded,
	        onError: this.props.onError
	      })), this.state.hasNoScript && _react.default.createElement("noscript", {
	        dangerouslySetInnerHTML: {
	          __html: noscriptImg((0, _extends2.default)({
	            alt: alt,
	            title: title
	          }, image))
	        }
	      }));
	    }
	
	    if (fixed) {
	      var _image = fixed;
	      var divStyle = (0, _extends2.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      return _react.default.createElement(Tag, {
	        className: (className ? className : "") + " gatsby-image-wrapper",
	        style: divStyle,
	        ref: this.handleRef,
	        key: "fixed-" + JSON.stringify(_image.srcSet)
	      }, _image.base64 && _react.default.createElement(Img, (0, _extends2.default)({
	        src: _image.base64
	      }, placeholderImageProps)), _image.tracedSVG && _react.default.createElement(Img, (0, _extends2.default)({
	        src: _image.tracedSVG
	      }, placeholderImageProps)), bgColor && _react.default.createElement(Tag, {
	        title: title,
	        style: {
	          backgroundColor: bgColor,
	          width: _image.width,
	          opacity: !this.state.imgLoaded ? 1 : 0,
	          transitionDelay: "0.25s",
	          height: _image.height
	        }
	      }), this.state.isVisible && _react.default.createElement("picture", null, _image.srcSetWebp && _react.default.createElement("source", {
	        type: "image/webp",
	        srcSet: _image.srcSetWebp,
	        sizes: _image.sizes
	      }), _react.default.createElement("source", {
	        srcSet: _image.srcSet,
	        sizes: _image.sizes
	      }), _react.default.createElement(Img, {
	        alt: alt,
	        title: title,
	        width: _image.width,
	        height: _image.height,
	        src: _image.src,
	        style: imageStyle,
	        ref: this.imageRef,
	        onLoad: this.handleImageLoaded,
	        onError: this.props.onError
	      })), this.state.hasNoScript && _react.default.createElement("noscript", {
	        dangerouslySetInnerHTML: {
	          __html: noscriptImg((0, _extends2.default)({
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height
	          }, _image))
	        }
	      }));
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react.default.Component);
	
	Image.defaultProps = {
	  critical: false,
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	var fixedObject = _propTypes.default.shape({
	  width: _propTypes.default.number.isRequired,
	  height: _propTypes.default.number.isRequired,
	  src: _propTypes.default.string.isRequired,
	  srcSet: _propTypes.default.string.isRequired,
	  base64: _propTypes.default.string,
	  tracedSVG: _propTypes.default.string,
	  srcWebp: _propTypes.default.string,
	  srcSetWebp: _propTypes.default.string
	});
	
	var fluidObject = _propTypes.default.shape({
	  aspectRatio: _propTypes.default.number.isRequired,
	  src: _propTypes.default.string.isRequired,
	  srcSet: _propTypes.default.string.isRequired,
	  sizes: _propTypes.default.string.isRequired,
	  base64: _propTypes.default.string,
	  tracedSVG: _propTypes.default.string,
	  srcWebp: _propTypes.default.string,
	  srcSetWebp: _propTypes.default.string
	});
	
	Image.propTypes = {
	  resolutions: fixedObject,
	  sizes: fluidObject,
	  fixed: fixedObject,
	  fluid: fluidObject,
	  fadeIn: _propTypes.default.bool,
	  title: _propTypes.default.string,
	  alt: _propTypes.default.string,
	  className: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
	  // Support Glamor's css prop.
	  critical: _propTypes.default.bool,
	  style: _propTypes.default.object,
	  imgStyle: _propTypes.default.object,
	  placeholderStyle: _propTypes.default.object,
	  placeholderClassName: _propTypes.default.string,
	  backgroundColor: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
	  onLoad: _propTypes.default.func,
	  onError: _propTypes.default.func,
	  onStartLoad: _propTypes.default.func,
	  Tag: _propTypes.default.string
	};
	var _default = Image;
	exports.default = _default;

/***/ }),

/***/ 68:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(158));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(86));
	
	var _reactLifecyclesCompat = __webpack_require__(68);
	
	var _PropTypes = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the components.
	 * It's up to you to give meaning and effect to those states. For example we can
	 * add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import Transition from 'react-transition-group/Transition';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {(state) => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
	 * What it does do is track transition states over time so you can update the
	 * component (such as by adding styles or classes) when it changes states.
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component begins the
	 * "Enter" stage. During this stage, the component will shift from its current transition state,
	 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
	 * it's complete. Let's take the following example:
	 *
	 * ```jsx
	 * state = { in: false };
	 *
	 * toggleEnterState = () => {
	 *   this.setState({ in: true });
	 * }
	 *
	 * render() {
	 *   return (
	 *     <div>
	 *       <Transition in={this.state.in} timeout={500} />
	 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state and
	 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
	 *
	 * ## Timing
	 *
	 * Timing is often the trickiest part of animation, mistakes can result in slight delays
	 * that are hard to pin down. A common example is when you want to add an exit transition,
	 * you should set the desired final styles when the state is `'exiting'`. That's when the
	 * transition to those styles will start and, if you matched the `timeout` prop with the
	 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
	 *
	 * > **Note**: For simpler transitions the `Transition` component might be enough, but
	 * > take into account that it's platform-agnostic, while the `CSSTransition` component
	 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * > in order to make more complex transitions more predictable. For example, even though
	 * > classes `example-enter` and `example-enter-active` are applied immediately one after
	 * > another, you can still transition from one to the other because of the forced reflow
	 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
	 * > for more info). Take this into account when choosing between `Transition` and
	 * > `CSSTransition`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  var _proto = Transition.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: null // allows for nested Transitions
	
	    };
	  };
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter;
	      appear = timeout.appear;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	    var timeouts = this.getTimeouts(); // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing); // FIXME: appear timeout?
	
	
	      _this2.onTransitionEnd(node, timeouts.enter, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	
	    if (node) {
	      if (this.props.addEndListener) {
	        this.props.addEndListener(node, this.nextCallback);
	      }
	
	      if (timeout != null) {
	        setTimeout(this.nextCallback, timeout);
	      }
	    } else {
	      setTimeout(this.nextCallback, 0);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return _react.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element.
	   * This function is called with the current transition status
	   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
	   * to apply context specific props to a component.
	   *
	   * ```jsx
	   * <Transition timeout={150}>
	   *   {(status) => (
	   *     <MyComponent className={`fade fade-${status}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided
	   *
	   * You may specify a single timeout for all transitions like: `timeout={500}`,
	   * or individually like:
	   *
	   * ```jsx
	   * timeout={{
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * @type {number | { enter?: number, exit?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = process.env.NODE_ENV !== "production" ? _PropTypes.timeoutsShape : {};;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
	
	exports.default = _default;

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.transitionTimeout = transitionTimeout;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(27));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.'); // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var timeoutsShape = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number
	}).isRequired]);
	
	exports.timeoutsShape = timeoutsShape;
	
	var classNamesShape = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]);
	
	exports.classNamesShape = classNamesShape;

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChevronIcon = function ChevronIcon(props) {
	  return _react2.default.createElement(
	    "svg",
	    { className: props.className, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 8 14" },
	    _react2.default.createElement("path", { d: "M9,19a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.42L13.59,12,8.29,6.71A1,1,0,0,1,9.71,5.29l6,6a1,1,0,0,1,0,1.42l-6,6A1,1,0,0,1,9,19Z",
	      transform: props.orientation || props.orientation && props.orientation.toLowerCase() === 'right' ? "translate(16 19) rotate(180)" : "translate(-8 -5)" })
	  );
	};
	
	exports.default = ChevronIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchCloseIcon = function SearchCloseIcon(props) {
	  return _react2.default.createElement(
	    "svg",
	    { className: props.className, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 14" },
	    _react2.default.createElement("path", { d: "M8.41,7l5.3,5.29a1,1,0,0,1-1.42,1.42L7,8.41l-5.29,5.3A1,1,0,0,1,.29,12.29L5.59,7,.29,1.71A1,1,0,0,1,1.71.29L7,5.59,12.29.29a1,1,0,1,1,1.42,1.42Z", transform: "translate(0 0)" })
	  );
	};
	
	exports.default = SearchCloseIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeroApplyArrow = function HeroApplyArrow(props) {
	  return _react2.default.createElement(
	    "svg",
	    { className: props.className, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 58 64" },
	    _react2.default.createElement("polygon", { points: "18.23 0 58 32 18.23 64 18.23 50.09 0 50.09 0 13.91 18.23 13.91 18.23 0" })
	  );
	};
	
	exports.default = HeroApplyArrow;
	module.exports = exports["default"];

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeHeroLogo = function HomeHeroLogo(props) {
	  return _react2.default.createElement(
	    "svg",
	    { className: props.className, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 135 290" },
	    _react2.default.createElement("rect", { width: "135", height: "290" }),
	    _react2.default.createElement("polygon", { points: "20 75 20 23 39 23 39 56 58 56 58 25 77 25 77 56 96 56 96 23 116 23 116 75 20 75" }),
	    _react2.default.createElement("polygon", { points: "20 107.17 20 88 115.86 112 116 112 116 131.04 115.86 131.18 20 155.18 20 136 77.66 121.52 20 107.17" }),
	    _react2.default.createElement("rect", { x: "20", y: "172", width: "96", height: "19" }),
	    _react2.default.createElement("polygon", { points: "58 229 20 229 20 210 115 210 115 229 77 229 77 248 116 248 116 267 20 267 20 248 58 248 58 229" })
	  );
	};
	
	exports.default = HomeHeroLogo;
	module.exports = exports["default"];

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlayIcon = function PlayIcon(props) {
	  return _react2.default.createElement(
	    "svg",
	    { xmlns: "http://www.w3.org/2000/svg",
	      width: "18", height: "18", viewBox: "0 0 24 24",
	      stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round",
	      className: "play-icon" },
	    _react2.default.createElement("polygon", { points: "5 3 19 12 5 21 5 3" })
	  );
	};
	
	exports.default = PlayIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Transition = __webpack_require__(52);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _reactRouter = __webpack_require__(88);
	
	var _lodash = __webpack_require__(154);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _markdown = __webpack_require__(8);
	
	var _markdown2 = _interopRequireDefault(_markdown);
	
	__webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Accordion = function (_React$Component) {
	  _inherits(Accordion, _React$Component);
	
	  function Accordion(props) {
	    _classCallCheck(this, Accordion);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      openedItems: _this.props.openedItems || {},
	      currentAnchor: ''
	    };
	
	    _this.toggleHandler = _this.toggleHandler.bind(_this);
	    _this.updateOpenedItems = _this.updateOpenedItems.bind(_this);
	
	    _this.anchors = {};
	    _this.props.content.items.forEach(function (item, index) {
	      if (item.anchor) {
	        _this.anchors[item.anchor] = ['' + index];
	      }
	
	      if (item.subItems) {
	        item.subItems.forEach(function (subItem, subIndex) {
	          _this.anchors[subItem.anchor] = ['' + index, index + '.' + subIndex];
	        });
	      }
	    });
	    return _this;
	  }
	
	  Accordion.prototype.componentDidMount = function componentDidMount() {
	    this.hasScrolled = false;
	    this.updateOpenedItems();
	  };
	
	  Accordion.prototype.componentDidUpdate = function componentDidUpdate(oldProps) {
	    if (!(0, _lodash2.default)(this.props.openedItems, oldProps.openedItems)) {
	      this.setState({
	        openedItems: this.props.openedItems
	      });
	    } else if (this.props.location.hash && this.state.currentAnchor !== this.props.location.hash) {
	      this.updateOpenedItems();
	    }
	
	    if (!this.hasScrolled && this.props.location.hash) {
	      this.scrollToItem();
	      this.hasScrolled = true;
	    }
	  };
	
	  Accordion.prototype.scrollToItem = function scrollToItem() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      var id = '#item-' + _this2.props.location.hash.substring(1);
	
	      var element = document.querySelector(id);
	      if (element) {
	        window.scrollTo(0, element.offsetTop);
	      }
	    }, 500);
	  };
	
	  Accordion.prototype.updateOpenedItems = function updateOpenedItems() {
	    var anchor = this.props.location.hash.substring(1);
	
	    if (anchor in this.anchors) {
	      var items = this.anchors[anchor];
	      var openedItems = _extends({}, this.state.openedItems);
	      items.forEach(function (item) {
	        return openedItems[item] = true;
	      });
	
	      this.setState({
	        currentAnchor: this.props.location.hash,
	        openedItems: openedItems
	      });
	    }
	  };
	
	  Accordion.prototype.toggleHandler = function toggleHandler(index) {
	    var key = '' + index;
	    var openedItems = _extends({}, this.state.openedItems);
	
	    openedItems[key] = !openedItems[key];
	
	    this.setState({
	      openedItems: openedItems
	    });
	  };
	
	  Accordion.prototype.renderSubItem = function renderSubItem(item, index) {
	    var _this3 = this;
	
	    var anchor = item.anchor ? 'item-' + item.anchor : null;
	
	    return _react2.default.createElement(
	      'div',
	      { key: item.id, id: anchor },
	      _react2.default.createElement(
	        'dt',
	        { className: 'accordion-sub-title', onClick: function onClick() {
	            return _this3.toggleHandler(index);
	          } },
	        item.title
	      ),
	      this.state.openedItems[index] ? _react2.default.createElement(
	        'dd',
	        { className: 'accordion-sub-content' },
	        item.content ? _react2.default.createElement(_markdown2.default, { content: item.content.content, highlightWord: this.props.highlightWord }) : ''
	      ) : null
	    );
	  };
	
	  Accordion.prototype.renderItem = function renderItem(item, index, state) {
	    var _this4 = this;
	
	    var classes = 'accordion-content nested ' + state;
	    if (item.subItems) {
	      return _react2.default.createElement(
	        'dd',
	        { className: classes },
	        _react2.default.createElement(
	          'dl',
	          { className: 'subitems-container' },
	          item.subItems.map(function (subItem, subIndex) {
	            return _this4.renderSubItem(subItem, index + '.' + subIndex);
	          })
	        )
	      );
	    } else {
	      var anchor = item.anchor ? '#item-' + item.anchor : null;
	      return _react2.default.createElement(
	        'dd',
	        { className: classes, id: anchor },
	        item.content ? _react2.default.createElement(_markdown2.default, { content: item.content.content, highlightWord: this.props.highlightWord }) : ''
	      );
	    }
	  };
	
	  Accordion.prototype.renderContent = function renderContent(content) {
	    if (content) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'text-content' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'heading' },
	          content.heading
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          content.body.body
	        )
	      );
	    } else {
	      return null;
	    }
	  };
	
	  Accordion.prototype.render = function render() {
	    var _this5 = this;
	
	    var contentBlock = this.renderContent(this.props.content.content);
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'standard-container accordion-container', 'data-cy': 'accordion' },
	      contentBlock,
	      _react2.default.createElement(
	        'div',
	        { className: 'accordion-wrapper ' + (!contentBlock ? 'accordion-fullwidth' : '') },
	        _react2.default.createElement(
	          'dl',
	          null,
	          this.props.content.items.map(function (item, index) {
	            var expandedClass = _this5.state.openedItems[index] ? 'expanded' : '';
	            return _react2.default.createElement(
	              'div',
	              { key: item.id },
	              _react2.default.createElement(
	                'dt',
	                { className: 'accordion-title ' + expandedClass,
	                  onClick: function onClick() {
	                    return _this5.toggleHandler(index);
	                  } },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'accordion-title-text' },
	                  item && item.title ? item.title : ''
	                )
	              ),
	              _react2.default.createElement(
	                _Transition2.default,
	                {
	                  'in': _this5.state.openedItems[index],
	                  timeout: { enter: 500, exit: 500 } },
	                function (state) {
	                  return state !== 'exited' ? _this5.renderItem(item, index, state) : null;
	                }
	              )
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return Accordion;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRouter.withRouter)(Accordion);
	module.exports = exports['default'];

/***/ }),

/***/ 114:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _cta = __webpack_require__(13);
	
	var _cta2 = _interopRequireDefault(_cta);
	
	var _logoGrid = __webpack_require__(44);
	
	var _logoGrid2 = _interopRequireDefault(_logoGrid);
	
	var _markdown = __webpack_require__(8);
	
	var _markdown2 = _interopRequireDefault(_markdown);
	
	var _submitForm = __webpack_require__(54);
	
	var _submitForm2 = _interopRequireDefault(_submitForm);
	
	var _timeline = __webpack_require__(45);
	
	var _timeline2 = _interopRequireDefault(_timeline);
	
	var _arrowRightIcon = __webpack_require__(42);
	
	var _arrowRightIcon2 = _interopRequireDefault(_arrowRightIcon);
	
	var _util = __webpack_require__(14);
	
	__webpack_require__(115);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Banner = function (_React$Component) {
	  _inherits(Banner, _React$Component);
	
	  function Banner(props) {
	    _classCallCheck(this, Banner);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Banner.prototype.renderLinks = function renderLinks(links) {
	    return links.map(function (item) {
	      return _react2.default.createElement(
	        'div',
	        { key: item.id },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '' + item.url },
	          item.question
	        )
	      );
	    });
	  };
	
	  Banner.prototype.renderCTAButton = function renderCTAButton(ctaContent) {
	    if (ctaContent) {
	      return _react2.default.createElement(_cta2.default, {
	        title: ctaContent.title,
	        url: ctaContent.url,
	        style: ctaContent.style });
	    } else {
	      return null;
	    }
	  };
	
	  Banner.prototype.renderForm = function renderForm(content) {
	    if (content) {
	      return _react2.default.createElement(_submitForm2.default, {
	        content: content,
	        localization: this.props.localization });
	    }
	    return null;
	  };
	
	  Banner.prototype.renderContent = function renderContent(content) {
	    if (content && content.body && content.body.body) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'content-container' },
	        _react2.default.createElement(_markdown2.default, { content: content.body.body })
	      );
	    }
	
	    return null;
	  };
	
	  Banner.prototype.renderTimeline = function renderTimeline(content) {
	    if (content) {
	      return _react2.default.createElement(_timeline2.default, { content: content });
	    } else {
	      return null;
	    }
	  };
	
	  Banner.prototype.renderLogoGrid = function renderLogoGrid(content) {
	    return _react2.default.createElement(_logoGrid2.default, { content: content, lang: this.props.lang });
	  };
	
	  Banner.prototype.renderComponents = function renderComponents(items) {
	    var _this2 = this;
	
	    if (items) {
	      return items.map(function (item) {
	        if (item.__typename == 'ContentfulCtaButton') {
	          return _this2.renderCTAButton(item);
	        } else if (item.__typename == 'ContentfulSubmitForm') {
	          return _this2.renderForm(item);
	        } else if (item.__typename == 'ContentfulLogoGrid') {
	          return _this2.renderLogoGrid(item);
	        } else if (item.__typename == 'ContentfulContentBlock') {
	          return _this2.renderContent(item);
	        } else if (item.__typename == 'ContentfulTimeline') {
	          return _this2.renderTimeline(item);
	        }
	      });
	    }
	
	    return null;
	  };
	
	  Banner.prototype.render = function render() {
	    var localization = this.props.localization;
	    var backgroundColor = this.props.content.backgroundColor || 'white';
	    var additionalClass = (0, _util.isColorBackground)(backgroundColor) ? 'color-background' : '';
	    var heading = this.props.content.heading || localization('global.faqTitle');
	    var renderedComponents = this.renderComponents(this.props.content.items);
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'banner-container ' + additionalClass, 'data-cy': 'banner', style: { backgroundColor: backgroundColor } },
	      _react2.default.createElement(
	        'h3',
	        null,
	        '< ',
	        heading,
	        ' >'
	      ),
	      this.props.content.extraBannerString ? _react2.default.createElement(
	        'div',
	        { className: 'description' },
	        _react2.default.createElement(_markdown2.default, { content: this.props.content.extraBannerString })
	      ) : null,
	      this.props.content.questions ? _react2.default.createElement(
	        'div',
	        { className: 'links-container' },
	        this.renderLinks(this.props.content.questions),
	        _react2.default.createElement(
	          'div',
	          { className: 'cta-container' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: 'btn secondary', to: '/' + this.props.lang + '/faq' },
	            this.props.localization('global.faqLink'),
	            ' ',
	            _react2.default.createElement(_arrowRightIcon2.default, { className: 'icon' })
	          )
	        )
	      ) : null,
	      _react2.default.createElement(
	        'div',
	        { className: 'cta-container' },
	        renderedComponents
	      )
	    );
	  };
	
	  return Banner;
	}(_react2.default.Component);
	
	exports.default = Banner;
	module.exports = exports['default'];

/***/ }),

/***/ 115:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CTAButton = function (_React$Component) {
	  _inherits(CTAButton, _React$Component);
	
	  function CTAButton(props) {
	    _classCallCheck(this, CTAButton);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  CTAButton.prototype.onClick = function onClick(e) {
	    if (this.props.onClick) {
	      e.preventDefault();
	      this.props.onClick();
	    }
	  };
	
	  CTAButton.prototype.render = function render() {
	    var to = this.props.onClick ? '' : this.props.url || '';
	    var externalLink = to.indexOf('mailto:') === 0 || to.indexOf('http') === 0;
	    var classes = 'btn ' + (this.props.style || (this.props.type === 'secondary' ? 'secondary' : 'primary'));
	
	    return externalLink ? _react2.default.createElement(
	      'a',
	      { className: classes, href: to, target: '_blank', rel: 'noopener' },
	      this.props.title
	    ) : _react2.default.createElement(
	      _gatsbyLink2.default,
	      { className: classes, to: to, onClick: this.onClick },
	      this.props.title
	    );
	  };
	
	  return CTAButton;
	}(_react2.default.Component);
	
	exports.default = CTAButton;
	module.exports = exports['default'];

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _markdown = __webpack_require__(8);
	
	var _markdown2 = _interopRequireDefault(_markdown);
	
	__webpack_require__(116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getImage = function getImage(image) {
	  var _image$sizes = image.sizes,
	      src = _image$sizes.src,
	      srcSet = _image$sizes.srcSet;
	
	
	  return { src: src, srcSet: srcSet, title: image.title };
	};
	
	var ContentBlock = function ContentBlock(_ref) {
	  var content = _ref.content;
	
	  var image = content.image && content.image.length > 0 ? getImage(content.image[0]) : null;
	
	  if (content) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'content-block-container standard-container', 'data-cy': 'contentblock' },
	      content.heading || content.body && content.body.body ? _react2.default.createElement(
	        'div',
	        { className: 'text-content' },
	        content.heading ? _react2.default.createElement(
	          'h2',
	          { className: 'heading' },
	          content.heading
	        ) : null,
	        content.body && content.body.body ? _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(_markdown2.default, { content: content.body.body })
	        ) : null
	      ) : null,
	      image ? _react2.default.createElement(
	        'div',
	        { className: 'feature-image-container' },
	        _react2.default.createElement('img', { src: image.src, srcSet: image.srcSet, className: 'feature-image', alt: image.title })
	      ) : null
	    );
	  } else {
	    return null;
	  }
	};
	
	exports.default = ContentBlock;
	module.exports = exports['default'];

/***/ }),

/***/ 116:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cta = __webpack_require__(13);
	
	var _cta2 = _interopRequireDefault(_cta);
	
	var _markdown = __webpack_require__(8);
	
	var _markdown2 = _interopRequireDefault(_markdown);
	
	__webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContentGrid = function (_React$Component) {
	  _inherits(ContentGrid, _React$Component);
	
	  function ContentGrid() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ContentGrid);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ContentGrid.prototype.componentDidMount = function componentDidMount() {
	    var styleOption = this.props.content.style === 'team-page' ? 'grid-team-page' : 'grid-standard';
	    this.setState({ styleOption: styleOption });
	  };
	
	  ContentGrid.prototype.renderGridItems = function renderGridItems(gridItems, columns) {
	    var _this2 = this;
	
	    var numCols = columns ? columns : 3;
	
	    if (gridItems) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'grid' },
	        gridItems.map(function (item, i) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'grid-item grid-col-' + numCols, key: i },
	            _this2.renderItem(item)
	          );
	        })
	      );
	    } else {
	      return null;
	    }
	  };
	
	  ContentGrid.prototype.renderItem = function renderItem(item) {
	    if (item) {
	      var imageUrl = item.image && item.image[0].file && item.image[0].file.url ? item.image[0].file.url : null;
	      var bgColor = item.backgroundColor ? { backgroundColor: item.backgroundColor } : {};
	      var textAlign = this.props.content.textAlign ? this.props.content.textAlign : '';
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        imageUrl ? _react2.default.createElement(
	          'div',
	          { className: 'grid-image-wrapper ' + this.state.styleOption + '-image', style: bgColor },
	          _react2.default.createElement('img', { src: imageUrl, className: 'grid-image' })
	        ) : null,
	        _react2.default.createElement(
	          'div',
	          { className: 'grid-content-wrapper ' + this.state.styleOption + '-content', style: _extends({ textAlign: textAlign }, imageUrl && this.state.styleOption !== 'grid-team-page' ? { padding: '0 1.5rem', marginTop: '-1.25rem' } : { padding: '0 1rem' }) },
	          item.heading ? _react2.default.createElement(
	            'h4',
	            { className: 'grid-item-heading', style: { textAlign: textAlign } },
	            item.heading
	          ) : null,
	          item.subheading ? _react2.default.createElement(
	            'h6',
	            { className: 'grid-item-subheading', style: { textAlign: textAlign } },
	            item.subheading
	          ) : null,
	          item.body && item.body.body ? _react2.default.createElement(
	            'div',
	            { className: 'grid-item-body' },
	            _react2.default.createElement(_markdown2.default, { content: item.body.body })
	          ) : null
	        )
	      );
	    } else {
	      return null;
	    }
	  };
	
	  ContentGrid.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props$content = this.props.content,
	        gridHeading = _props$content.gridHeading,
	        gridItems = _props$content.gridItems,
	        ctaButtons = _props$content.ctaButtons,
	        columns = _props$content.columns;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'grid-container', 'data-cy': 'content-grid' },
	      gridHeading ? _react2.default.createElement(
	        'h1',
	        { className: 'grid-heading ' + this.state.styleOption + '-heading' },
	        gridHeading
	      ) : null,
	      this.renderGridItems(gridItems, columns),
	      ctaButtons ? _react2.default.createElement(
	        'div',
	        { className: 'grid-cta' },
	        ctaButtons.map(function (cta, i) {
	          return _react2.default.createElement(_cta2.default, { type: i > 0 ? 'secondary' : 'primary', title: cta.title, url: cta.url, key: i, lang: _this3.props.lang, style: cta.style });
	        })
	      ) : null
	    );
	  };
	
	  return ContentGrid;
	}(_react2.default.Component);
	
	exports.default = ContentGrid;
	module.exports = exports['default'];

/***/ }),

/***/ 117:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _util = __webpack_require__(14);
	
	var _config = __webpack_require__(33);
	
	__webpack_require__(217);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Countdown = function (_React$Component) {
	  _inherits(Countdown, _React$Component);
	
	  function Countdown(props) {
	    _classCallCheck(this, Countdown);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      currentTime: null
	    };
	    return _this;
	  }
	
	  Countdown.prototype.componentDidMount = function componentDidMount() {
	    if (!this.timer) {
	      this.getCurrentTime();
	    }
	  };
	
	  Countdown.prototype.getCurrentTime = function getCurrentTime() {
	    if (typeof window !== 'undefined') {
	      var currentTime = +new Date();
	      this.startTimer(currentTime);
	      /*
	      httpGetAsync(
	        timeApiUrl,
	        (currentTime) => {
	          this.startTimer(Number(currentTime))
	        },
	        () => {
	          const currentTime = +new Date()
	          this.startTimer(currentTime)
	        }
	      )*/
	    }
	  };
	
	  Countdown.prototype.startTimer = function startTimer(time) {
	    var _this2 = this;
	
	    var timeElapsed = 0;
	
	    this.timer = setInterval(function () {
	      timeElapsed += 1000;
	
	      _this2.setState({
	        currentTime: time + timeElapsed
	      });
	    }, 1000);
	  };
	
	  Countdown.prototype.parseTimeDiff = function parseTimeDiff(diff) {
	    // const days = Math.ceil(diff / (3600 * 24 * 1000))
	    var days = Math.floor(diff / (3600 * 24 * 1000));
	    var hours = Math.floor(diff % (3600 * 24 * 1000) / (3600 * 1000));
	    var minutes = Math.floor(diff % 3.6e6 / 6e4);
	    var seconds = Math.floor(diff % 6e4 / 1000);
	
	    return { days: days, hours: hours, minutes: minutes, seconds: seconds };
	  };
	
	  Countdown.prototype.renderTime = function renderTime() {
	    var localization = this.props.localization;
	
	    if (this.state.currentTime) {
	      var diff = _config.launchTimestamp - this.state.currentTime;
	
	      if (diff > 0) {
	        var _parseTimeDiff = this.parseTimeDiff(diff),
	            days = _parseTimeDiff.days,
	            hours = _parseTimeDiff.hours,
	            minutes = _parseTimeDiff.minutes,
	            seconds = _parseTimeDiff.seconds;
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'countdown-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'description' },
	            localization('global.applicationsStart')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'time-container' },
	            _react2.default.createElement(
	              'span',
	              { className: 'time-value' },
	              days
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'time-description' },
	              localization('global.days')
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'time-value' },
	              hours
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'time-description' },
	              localization('global.hours')
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'time-value' },
	              minutes
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'time-description' },
	              localization('global.minutes')
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'time-value' },
	              seconds
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'time-description' },
	              localization('global.seconds')
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'description centered' },
	          localization('global.applicationOpen')
	        );
	      }
	    } else {
	      return null;
	    }
	  };
	
	  Countdown.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'countdown-container' },
	      this.renderTime()
	    );
	  };
	
	  return Countdown;
	}(_react2.default.Component);
	
	exports.default = Countdown;
	module.exports = exports['default'];

/***/ }),

/***/ 217:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _removeMarkdown = __webpack_require__(130);
	
	var _removeMarkdown2 = _interopRequireDefault(_removeMarkdown);
	
	var _util = __webpack_require__(14);
	
	var _cta = __webpack_require__(13);
	
	var _cta2 = _interopRequireDefault(_cta);
	
	var _markdown = __webpack_require__(8);
	
	var _markdown2 = _interopRequireDefault(_markdown);
	
	__webpack_require__(118);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DualBox = function (_React$Component) {
	  _inherits(DualBox, _React$Component);
	
	  function DualBox() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DualBox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.copyToClipboard = _this.copyToClipboard.bind(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DualBox.prototype.copyToClipboard = function copyToClipboard(content) {
	    var plainContent = (0, _removeMarkdown2.default)(content);
	    var txt = document.createTextNode(plainContent);
	    document.body.appendChild(txt);
	
	    if (document.body.createTextRange) {
	      var d = document.body.createTextRange();
	
	      d.moveToElementText(txt);
	      d.select();
	      document.execCommand('copy');
	    } else {
	      var _d = document.createRange();
	
	      _d.selectNodeContents(txt);
	      window.getSelection().removeAllRanges();
	      window.getSelection().addRange(_d);
	      document.execCommand('copy');
	      window.getSelection().removeAllRanges();
	    }
	
	    txt.remove();
	  };
	
	  DualBox.prototype.renderPanel = function renderPanel(panel) {
	    var _this2 = this;
	
	    var ctas = panel.ctaButtons ? panel.ctaButtons.map(function (cta, i) {
	      var url = cta.url;
	      var onClick = url === '#copyToClipboard' ? function () {
	        return _this2.copyToClipboard(panel.body.body);
	      } : null;
	      var style = cta.style;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'button-container', key: i },
	        _react2.default.createElement(_cta2.default, { title: cta.title, url: url, onClick: onClick, style: style })
	      );
	    }) : [];
	
	    var additionalClass = (0, _util.isColorBackground)(panel.backgroundColor) ? 'color-background' : '';
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: 'panel-container ' + additionalClass,
	        style: { 'backgroundColor': panel.backgroundColor } },
	      _react2.default.createElement(
	        'h3',
	        null,
	        panel.heading
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'panel-content' },
	        _react2.default.createElement(_markdown2.default, { content: panel.body.body }),
	        ctas.length > 0 ? _react2.default.createElement(
	          'div',
	          { className: 'button-container' },
	          ctas
	        ) : null
	      )
	    );
	  };
	
	  DualBox.prototype.render = function render() {
	    var _props$content = this.props.content,
	        leftPanel = _props$content.leftPanel,
	        rightPanel = _props$content.rightPanel;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'dualbox-container standard-container' },
	      this.renderPanel(leftPanel),
	      this.renderPanel(rightPanel)
	    );
	  };
	
	  return DualBox;
	}(_react2.default.Component);
	
	exports.default = DualBox;
	module.exports = exports['default'];

/***/ }),

/***/ 118:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(22);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _countdown = __webpack_require__(164);
	
	var _countdown2 = _interopRequireDefault(_countdown);
	
	var _homeHeroLogo = __webpack_require__(162);
	
	var _homeHeroLogo2 = _interopRequireDefault(_homeHeroLogo);
	
	var _heroApplyArrow = __webpack_require__(161);
	
	var _heroApplyArrow2 = _interopRequireDefault(_heroApplyArrow);
	
	__webpack_require__(218);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderBackground = function renderBackground(background) {
	  var file = background.file;
	
	  if (file.contentType.startsWith('video')) {
	    return _react2.default.createElement(
	      'video',
	      { width: '100%', muted: true, autoPlay: true, loop: true, playsInline: true },
	      _react2.default.createElement('source', { src: file.url, type: 'video/mp4' })
	    );
	  } else {
	    return _react2.default.createElement(_gatsbyImage2.default, { className: 'hero-background-image', sizes: background.sizes });
	  }
	};
	
	var HeroHome = function HeroHome(_ref) {
	  var content = _ref.content,
	      lang = _ref.lang,
	      localization = _ref.localization;
	
	  var background = renderBackground(content.background);
	
	  if (content) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'hero-container', 'data-cy': 'hero' },
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-background-image-wrapper' },
	        background
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-content ' + lang },
	        _react2.default.createElement(
	          'div',
	          { className: 'hero-header ' + lang },
	          _react2.default.createElement(
	            'div',
	            { className: 'hero-logo-container ' + lang },
	            _react2.default.createElement(_homeHeroLogo2.default, { className: 'hero-logo' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'hero-heading ' + lang },
	            content.heading ? _react2.default.createElement(
	              'h1',
	              null,
	              content.heading
	            ) : null
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'hero-countdown-container' },
	          _react2.default.createElement(_countdown2.default, { localization: localization })
	        ),
	        localization('global.applyNow') && localization('global.applyUrl') ? _react2.default.createElement(
	          'a',
	          { href: localization('global.applyUrl'), target: '_blank', rel: 'noopener', className: 'hero-apply-container ' + lang },
	          _react2.default.createElement(
	            'h2',
	            null,
	            localization('global.applyNow')
	          ),
	          _react2.default.createElement(_heroApplyArrow2.default, { className: 'hero-apply-arrow' })
	        ) : null
	      )
	    );
	  } else {
	    return null;
	  }
	};
	
	exports.default = HeroHome;
	module.exports = exports['default'];

/***/ }),

/***/ 218:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _breadcrumbs = __webpack_require__(95);
	
	var _breadcrumbs2 = _interopRequireDefault(_breadcrumbs);
	
	var _youtubePlayer = __webpack_require__(106);
	
	var _youtubePlayer2 = _interopRequireDefault(_youtubePlayer);
	
	var _util = __webpack_require__(14);
	
	var _playIcon = __webpack_require__(93);
	
	var _playIcon2 = _interopRequireDefault(_playIcon);
	
	__webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeroSub = function (_React$Component) {
	  _inherits(HeroSub, _React$Component);
	
	  function HeroSub(props) {
	    _classCallCheck(this, HeroSub);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.mediaContainer = _react2.default.createRef();
	    _this.onClick = _this.onClick.bind(_this);
	    _this.closeVideo = _this.closeVideo.bind(_this);
	
	    _this.state = {
	      playVideo: false
	    };
	    return _this;
	  }
	
	  HeroSub.prototype.onClick = function onClick() {
	    this.setState({
	      playVideo: true
	    });
	  };
	
	  HeroSub.prototype.closeVideo = function closeVideo() {
	    this.setState({
	      playVideo: false
	    });
	  };
	
	  HeroSub.prototype.renderVideoControls = function renderVideoControls(image, localization) {
	    if (!image) {
	      return null;
	    }
	
	    var heading = image.description || image.title;
	    return _react2.default.createElement(
	      'div',
	      { className: 'video-controls-container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'description' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          heading
	        )
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn primary play-button', onClick: this.onClick },
	        localization('global.watchVideo'),
	        ' ',
	        _react2.default.createElement(_playIcon2.default, null)
	      )
	    );
	  };
	
	  HeroSub.prototype.render = function render() {
	    var _props = this.props,
	        content = _props.content,
	        lang = _props.lang,
	        localization = _props.localization;
	
	
	    if (!content) {
	      return null;
	    }
	
	    var backgroundColor = content.backgroundColor || '#F8D4D2';
	    var alignSubheroImage = content.alignSubheroImage ? content.alignSubheroImage : 'top';
	
	    var _ref = content.background && content.background.sizes ? content.background.sizes : { src: '', srcSet: '' },
	        src = _ref.src,
	        srcSet = _ref.srcSet;
	
	    var videoControls = content.videoUrl ? this.renderVideoControls(content.background, localization) : null;
	    var videoHeight = this.mediaContainer.current ? this.mediaContainer.current.clientHeight : '100%';
	    var videoPlayer = content.videoUrl && (0, _util.parseUrlParameters)(content.videoUrl).v ? _react2.default.createElement(_youtubePlayer2.default, { url: content.videoUrl, play: this.state.playVideo, height: videoHeight, closeVideo: this.closeVideo, localization: localization }) : null;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'subhero-container' },
	      content.background && !content.videoUrl ? _react2.default.createElement(
	        'div',
	        { className: 'image-container' },
	        _react2.default.createElement('img', { src: src, srcSet: srcSet, className: 'hero-image ' + alignSubheroImage, alt: '' })
	      ) : null,
	      content.background && content.videoUrl ? _react2.default.createElement('div', { className: 'media-backdrop', style: { backgroundColor: backgroundColor } }) : null,
	      content.background && content.videoUrl ? _react2.default.createElement(
	        'div',
	        { className: 'media-container', ref: this.mediaContainer },
	        videoControls,
	        videoPlayer,
	        _react2.default.createElement('img', { src: src, srcSet: srcSet, className: 'media-image', alt: '' })
	      ) : null,
	      _react2.default.createElement(_breadcrumbs2.default, { lang: lang, localization: localization }),
	      content.heading ? _react2.default.createElement(
	        'h1',
	        { className: 'subhero-heading' },
	        content.heading
	      ) : null,
	      content.body ? _react2.default.createElement('div', { className: 'subhero-content', dangerouslySetInnerHTML: { __html: content.body.body } }) : null
	    );
	  };
	
	  return HeroSub;
	}(_react2.default.Component);
	
	exports.default = HeroSub;
	module.exports = exports['default'];

/***/ }),

/***/ 119:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _markdown = __webpack_require__(8);
	
	var _markdown2 = _interopRequireDefault(_markdown);
	
	var _gatsbyImage = __webpack_require__(22);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	__webpack_require__(120);
	
	var _chevronIcon = __webpack_require__(91);
	
	var _chevronIcon2 = _interopRequireDefault(_chevronIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageCarousel = function (_React$Component) {
	  _inherits(ImageCarousel, _React$Component);
	
	  function ImageCarousel() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ImageCarousel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      showImage: 0
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ImageCarousel.prototype.renderPrev = function renderPrev() {
	    if (this.state.showImage > 0) {
	      this.setState(function (prevState) {
	        return { showImage: prevState.showImage - 1 };
	      });
	    } else if (this.state.showImage === 0) {
	      this.setState({ showImage: this.props.content.images.length - 1 });
	    }
	  };
	
	  ImageCarousel.prototype.renderNext = function renderNext() {
	    if (this.state.showImage < this.props.content.images.length - 1) {
	      this.setState(function (prevState) {
	        return { showImage: prevState.showImage + 1 };
	      });
	    } else if (this.state.showImage === this.props.content.images.length - 1) {
	      this.setState({ showImage: 0 });
	    }
	  };
	
	  ImageCarousel.prototype.render = function render() {
	    var _this2 = this;
	
	    var content = this.props.content;
	
	    if (content && content.images) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'image-carousel-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'carousel-image-wrapper' },
	          content.images.length > 1 ? _react2.default.createElement(
	            'div',
	            { className: 'show-arrows-desktop' },
	            _react2.default.createElement(
	              'button',
	              { className: 'carousel-pagination-arrow-btn', onClick: this.renderPrev.bind(this) },
	              _react2.default.createElement(_chevronIcon2.default, { className: 'carousel-chevron', orientation: 'left' })
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'carousel-pagination-arrow-btn', onClick: this.renderNext.bind(this) },
	              _react2.default.createElement(_chevronIcon2.default, { className: 'carousel-chevron' })
	            )
	          ) : null,
	          content.images[this.state.showImage] && content.images[this.state.showImage].sizes ? _react2.default.createElement(_gatsbyImage2.default, { sizes: content.images[this.state.showImage].sizes, className: 'carousel-image' }) : null
	        ),
	        content.images.length > 1 ? _react2.default.createElement(
	          'div',
	          { className: 'carousel-pagination' },
	          _react2.default.createElement(
	            'button',
	            { className: 'carousel-pagination-arrow-btn show-arrows-mobile', onClick: this.renderPrev.bind(this) },
	            _react2.default.createElement(_chevronIcon2.default, { className: 'carousel-chevron', orientation: 'left' })
	          ),
	          content.images.map(function (image, i) {
	            return _react2.default.createElement(
	              'button',
	              { onClick: function onClick() {
	                  return _this2.setState({ showImage: i });
	                }, key: i, className: "btn-pagination " + (_this2.state.showImage === i ? "btn-pagination-active" : "") },
	              i + 1
	            );
	          }),
	          _react2.default.createElement(
	            'button',
	            { className: 'carousel-pagination-arrow-btn show-arrows-mobile', onClick: this.renderNext.bind(this) },
	            _react2.default.createElement(_chevronIcon2.default, { className: 'carousel-chevron' })
	          )
	        ) : null,
	        _react2.default.createElement(
	          'div',
	          { className: 'carousel-content' },
	          content.images[this.state.showImage] && content.images[this.state.showImage].title ? _react2.default.createElement(
	            'h3',
	            { className: 'carousel-content-title' },
	            content.images[this.state.showImage].title
	          ) : null,
	          content.images[this.state.showImage] && content.images[this.state.showImage].description ? _react2.default.createElement(
	            'div',
	            { className: 'carousel-content-description' },
	            _react2.default.createElement(_markdown2.default, { content: content.images[this.state.showImage].description })
	          ) : null
	        )
	      );
	    } else {
	      return null;
	    }
	  };
	
	  return ImageCarousel;
	}(_react2.default.Component);
	
	exports.default = ImageCarousel;
	module.exports = exports['default'];

/***/ }),

/***/ 120:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(22);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	__webpack_require__(121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LogoGrid = function (_React$Component) {
	  _inherits(LogoGrid, _React$Component);
	
	  function LogoGrid() {
	    _classCallCheck(this, LogoGrid);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  LogoGrid.prototype.render = function render() {
	    var content = this.props.content;
	
	    if (content) {
	      var gridType = content.gridType ? content.gridType : 'primary';
	      var logos = content.logo ? content.logo : [];
	      var backgroundColor = content.gridBackgroundColor ? content.gridBackgroundColor : null;
	      var style = { objectFit: 'contain' };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'logo-grid-container', style: { backgroundColor: backgroundColor } },
	        logos.map(function (logo, i) {
	          return _react2.default.createElement(
	            'div',
	            { key: i, className: 'grid-logo-wrapper ' + gridType },
	            _react2.default.createElement(_gatsbyImage2.default, { className: 'grid-logo', sizes: logo.sizes, imgStyle: style })
	          );
	        })
	      );
	    } else {
	      return null;
	    }
	  };
	
	  return LogoGrid;
	}(_react2.default.Component);
	
	exports.default = LogoGrid;
	module.exports = exports['default'];

/***/ }),

/***/ 121:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _slugify = __webpack_require__(53);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	var _config = __webpack_require__(33);
	
	__webpack_require__(122);
	
	var _arrowRightIcon = __webpack_require__(42);
	
	var _arrowRightIcon2 = _interopRequireDefault(_arrowRightIcon);
	
	var _clockIcon = __webpack_require__(92);
	
	var _clockIcon2 = _interopRequireDefault(_clockIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderImage = function renderImage(image) {
	  if (image) {
	    var _image$sizes = image.sizes,
	        src = _image$sizes.src,
	        srcSet = _image$sizes.srcSet,
	        title = _image$sizes.title;
	
	    return _react2.default.createElement('img', { src: src, srcSet: srcSet, className: 'feature-image', alt: title });
	  }
	
	  return null;
	};
	
	var renderArticle = function renderArticle(article, lang) {
	  var image = renderImage(article.featureImage);
	  var backgroundColor = article.backgroundColor || 'white';
	  var linkClass = image ? '' : 'no-image';
	  var path = (0, _slugify2.default)(article.heading, _config.slugifyOptions);
	
	  return _react2.default.createElement(
	    'div',
	    { style: { backgroundColor: backgroundColor }, className: 'article-container', key: path },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/' + lang + '/article/' + path, className: 'unstyled article-link ' + linkClass },
	      _react2.default.createElement(
	        'div',
	        { className: 'image-container' },
	        image
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'article-content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'content-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'date' },
	            _react2.default.createElement(_clockIcon2.default, { className: 'icon' }),
	            ' ',
	            _react2.default.createElement(
	              'time',
	              { className: 'created-at' },
	              article.createdAt
	            )
	          ),
	          _react2.default.createElement(
	            'h5',
	            null,
	            article.heading
	          )
	        )
	      )
	    )
	  );
	};
	
	var NewsList = function NewsList(_ref) {
	  var content = _ref.content,
	      news = _ref.news,
	      lang = _ref.lang;
	
	  var allNewsURL = lang === 'fi' ? '/fi/uutiset' : '/en/news';
	
	  if (!news) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'news-list-container', 'data-cy': 'news' },
	    _react2.default.createElement(
	      'h3',
	      { className: 'news-list-heading' },
	      content && content.heading ? content.heading : null
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'news-container' },
	      news.map(function (article) {
	        return renderArticle(article.node, lang);
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'all-news-link-wrapper' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: allNewsURL, className: 'all-news-link' },
	        content && content.moreLink ? content.moreLink : null
	      ),
	      _react2.default.createElement(_arrowRightIcon2.default, { className: 'all-news-arrow icon' })
	    )
	  );
	};
	
	exports.default = NewsList;
	module.exports = exports['default'];

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(123);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Quote = function Quote(_ref) {
	  var content = _ref.content;
	
	  var justifyQuote = content.justifyQuote.toLowerCase() === 'left' ? 'flex-start' : content.justifyQuote.toLowerCase() === 'center' ? 'center' : content.justifyQuote.toLowerCase() === 'right' ? 'flex-end' : 'flex-start';
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'quote-container', style: { justifyContent: justifyQuote }, 'data-cy': 'quote' },
	    _react2.default.createElement(
	      'div',
	      { className: 'quote-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'quote-body' },
	        _react2.default.createElement(
	          'span',
	          { className: 'quote-mark' },
	          '\u201C'
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          content.quote.quote
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'quote-mark' },
	          '\u201D'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'quote-author' },
	        '- ',
	        content.author
	      )
	    )
	  );
	};
	
	exports.default = Quote;
	module.exports = exports['default'];

/***/ }),

/***/ 123:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(124);
	
	var _cta = __webpack_require__(13);
	
	var _cta2 = _interopRequireDefault(_cta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SkillsList = function (_React$Component) {
	  _inherits(SkillsList, _React$Component);
	
	  function SkillsList() {
	    _classCallCheck(this, SkillsList);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SkillsList.prototype.renderCTAButton = function renderCTAButton(ctaContent) {
	    if (ctaContent) {
	      return _react2.default.createElement(_cta2.default, {
	        title: ctaContent.title,
	        url: ctaContent.url,
	        style: ctaContent.style });
	    } else {
	      return null;
	    }
	  };
	
	  SkillsList.prototype.render = function render() {
	    var content = this.props.content;
	    var renderedComponents = this.renderCTAButton(content.cta);
	    return _react2.default.createElement(
	      'div',
	      { 'data-cy': 'skills-list', className: 'skills-container standard-container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'header' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          content.heading ? content.heading : null
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          content.body && content.body.body ? content.body.body : null
	        )
	      ),
	      _react2.default.createElement(
	        'ol',
	        { className: 'skills-list' },
	        content.skillItems.map(function (item, index) {
	          return _react2.default.createElement(
	            'li',
	            { key: item.id },
	            _react2.default.createElement(
	              'h4',
	              null,
	              item.title ? item.title : ''
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              item.body && item.body.body ? item.body.body : null
	            )
	          );
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'cta-container' },
	        renderedComponents
	      )
	    );
	  };
	
	  return SkillsList;
	}(_react2.default.Component);
	
	exports.default = SkillsList;
	module.exports = exports['default'];

/***/ }),

/***/ 124:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cta = __webpack_require__(13);
	
	var _cta2 = _interopRequireDefault(_cta);
	
	var _markdown = __webpack_require__(8);
	
	var _markdown2 = _interopRequireDefault(_markdown);
	
	__webpack_require__(125);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Story = function (_React$Component) {
	  _inherits(Story, _React$Component);
	
	  function Story() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Story);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      showImage: null
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Story.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.content) {
	
	      var content = this.props.content;
	      var contentBlock = content && content.content ? content.content : null;
	
	      this.setState(_extends({}, content && content.storyVariation ? { storyVariation: content.storyVariation } : { storyVariation: 'standard' }, content && content.textPosition ? { textPosition: content.textPosition } : { textPosition: 'Left' }, content && content.featureImageType ? { featureImageType: content.featureImageType } : { featureImageType: 'normal' }, contentBlock && contentBlock.backgroundColor ? { style: { backgroundColor: contentBlock.backgroundColor } } : { style: {} }, contentBlock && contentBlock.image && contentBlock.image[0].file && contentBlock.image[0].file.url ? { imageUrl: contentBlock.image[0].file.url } : {}, content && content.storyVariation === 'image-carousel' && contentBlock && contentBlock.image ? { carouselImages: contentBlock.image } : {}, contentBlock && contentBlock.heading ? { heading: contentBlock.heading } : {}, contentBlock && contentBlock.body && contentBlock.body.body ? { body: contentBlock.body.body } : {}, contentBlock && contentBlock.ctaButtons && contentBlock.ctaButtons[0] && contentBlock.ctaButtons[0].title && contentBlock.ctaButtons[0].url ? { btnPrimary: { title: contentBlock.ctaButtons[0].title, url: contentBlock.ctaButtons[0].url } } : {}, contentBlock && contentBlock.ctaButtons && contentBlock.ctaButtons[1] && contentBlock.ctaButtons[1].title && contentBlock.ctaButtons[1].url ? { btnSecondary: { title: contentBlock.ctaButtons[1].title, url: contentBlock.ctaButtons[1].url } } : {}, content && content.storyVariation === 'image-carousel' && contentBlock && contentBlock.image ? { showImage: 0 } : { showImage: null }));
	    }
	  };
	
	  Story.prototype.render = function render() {
	    var _this2 = this;
	
	    if (this.state.storyVariation === 'full-width' || this.state.storyVariation === 'standard') {
	      return _react2.default.createElement(
	        'div',
	        { className: this.state.storyVariation === 'full-width' ? "story-fullwidth" : "story-standard", style: this.state.storyVariation === 'full-width' ? this.state.style : {} },
	        _react2.default.createElement(
	          'div',
	          { className: "story-content-wrapper " + (this.state.featureImageType === 'background' ? "story-content-full " : "story-content-half ") + (this.state.featureImageType === 'background' && this.state.textPosition === 'Right' ? "story-justify-right" : this.state.featureImageType === 'background' ? "story-justify-left" : this.state.featureImageType === 'normal' && this.state.textPosition === 'Right' ? "story-order-right" : "story-order-left"),
	            style: this.state.style },
	          _react2.default.createElement(
	            'div',
	            { className: 'story-content' },
	            this.state.heading ? _react2.default.createElement(
	              'h2',
	              { className: 'story-heading' },
	              this.state.heading
	            ) : null,
	            this.state.body ? _react2.default.createElement(
	              'div',
	              { className: 'story-body' },
	              _react2.default.createElement(_markdown2.default, { content: this.state.body })
	            ) : null,
	            this.state.btnPrimary ? _react2.default.createElement(
	              'div',
	              { className: 'story-cta' },
	              _react2.default.createElement(_cta2.default, { title: this.state.btnPrimary.title, url: this.state.btnPrimary.url, style: this.state.btnPrimary.style })
	            ) : null,
	            this.state.btnSecondary ? _react2.default.createElement(
	              'div',
	              { className: 'story-cta' },
	              _react2.default.createElement(_cta2.default, { title: this.state.btnSecondary.title, url: this.state.btnSecondary.url, style: this.state.btnPrimary.style })
	            ) : null
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: "story-image-wrapper " + (this.state.featureImageType === 'background' ? "story-image-full " : "story-image-half ") + (this.state.featureImageType === 'normal' && this.state.textPosition === 'Right' ? "story-order-left" : "story-order-right"),
	            style: this.state.style },
	          _react2.default.createElement('img', { src: this.state.imageUrl, className: 'story-image' })
	        )
	      );
	    } else if (this.state.storyVariation === '50-50') {
	      return _react2.default.createElement(
	        'div',
	        { className: 'story-50-50' },
	        _react2.default.createElement(
	          'div',
	          { className: "story-content-wrapper " + (this.state.textPosition === 'Right' ? "story-order-right" : "story-order-left"),
	            style: this.state.style },
	          _react2.default.createElement(
	            'div',
	            { className: 'story-content' },
	            this.state.heading ? _react2.default.createElement(
	              'h2',
	              { className: 'story-heading' },
	              this.state.heading
	            ) : null,
	            this.state.body ? _react2.default.createElement(
	              'div',
	              { className: 'story-body' },
	              _react2.default.createElement(_markdown2.default, { content: this.state.body })
	            ) : null,
	            this.state.btnPrimary ? _react2.default.createElement(
	              'div',
	              { className: 'story-cta' },
	              _react2.default.createElement(_cta2.default, { title: this.state.btnPrimary.title, url: this.state.btnPrimary.url, style: this.state.btnPrimary.style })
	            ) : null,
	            this.state.btnSecondary ? _react2.default.createElement(
	              'div',
	              { className: 'story-cta' },
	              _react2.default.createElement(_cta2.default, { title: this.state.btnSecondary.title, url: this.state.btnSecondary.url, style: this.state.btnPrimary.style })
	            ) : null
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: "story-image-wrapper " + (this.state.textPosition === 'Right' ? "story-order-left" : "story-order-right"), style: this.state.style },
	          _react2.default.createElement('img', { src: this.state.imageUrl, className: 'story-image' })
	        )
	      );
	    } else if (this.state.storyVariation === 'image-carousel') {
	      return _react2.default.createElement(
	        'div',
	        { className: 'story-image-carousel' },
	        _react2.default.createElement(
	          'div',
	          { className: "story-content-wrapper " + (this.state.textPosition === 'Right' ? "story-order-right" : "story-order-left"),
	            style: this.state.style },
	          _react2.default.createElement(
	            'div',
	            { className: 'story-content' },
	            this.state.heading ? _react2.default.createElement(
	              'h2',
	              { className: 'story-heading' },
	              this.state.heading
	            ) : null,
	            this.state.body ? _react2.default.createElement(
	              'div',
	              { className: 'story-body' },
	              _react2.default.createElement(_markdown2.default, { content: this.state.body })
	            ) : null,
	            this.state.btnPrimary ? _react2.default.createElement(
	              'div',
	              { className: 'story-cta' },
	              _react2.default.createElement(_cta2.default, { title: this.state.btnPrimary.title, url: this.state.btnPrimary.url, style: this.state.btnPrimary.style })
	            ) : null,
	            this.state.btnSecondary ? _react2.default.createElement(
	              'div',
	              { className: 'story-cta' },
	              _react2.default.createElement(_cta2.default, { title: this.state.btnSecondary.title, url: this.state.btnSecondary.url, style: this.state.btnPrimary.style })
	            ) : null
	          )
	        ),
	        this.state.carouselImages ? _react2.default.createElement(
	          'div',
	          { className: "story-image-wrapper " + (this.state.textPosition === 'Right' ? "story-order-left" : "story-order-right"), style: _extends({}, this.state.style, this.state.textPosition === 'Left' ? { alignItems: 'flex-start' } : {}) },
	          _react2.default.createElement('img', { src: this.state.carouselImages[this.state.showImage].file.url, className: 'story-image' }),
	          this.state.carouselImages.length > 1 ? _react2.default.createElement(
	            'div',
	            { className: 'carousel-pagination' },
	            this.state.carouselImages.map(function (image, i) {
	              return _react2.default.createElement(
	                'button',
	                { onClick: function onClick() {
	                    return _this2.setState({ showImage: i });
	                  }, key: i, className: "btn-pagination " + (_this2.state.showImage === i ? "btn-pagination-active" : "") },
	                i + 1
	              );
	            })
	          ) : null
	        ) : null
	      );
	    } else {
	      return _react2.default.createElement('div', null);
	    }
	  };
	
	  return Story;
	}(_react2.default.Component);
	
	exports.default = Story;
	module.exports = exports['default'];

/***/ }),

/***/ 125:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(67);
	
	var _markdown = __webpack_require__(8);
	
	var _markdown2 = _interopRequireDefault(_markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubmitForm = function (_React$Component) {
	  _inherits(SubmitForm, _React$Component);
	
	  function SubmitForm(props) {
	    _classCallCheck(this, SubmitForm);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  SubmitForm.prototype.renderField = function renderField(name, value) {
	    if (name && value) {
	      return _react2.default.createElement('input', { type: 'hidden', name: name, value: value });
	    } else {
	      return null;
	    }
	  };
	
	  SubmitForm.prototype.render = function render() {
	    var _props = this.props,
	        localization = _props.localization,
	        content = _props.content;
	    var actionUrl = content.actionUrl,
	        description = content.description,
	        layout = content.layout,
	        formId = content.formId,
	        u = content.u;
	
	    var uField = this.renderField('u', u);
	    var idField = this.renderField('id', formId);
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'form-container' },
	      description ? _react2.default.createElement(
	        'div',
	        { className: 'description' },
	        _react2.default.createElement(_markdown2.default, { content: description.description })
	      ) : null,
	      _react2.default.createElement(
	        'form',
	        { action: actionUrl, method: 'POST', className: 'submit-form' },
	        _react2.default.createElement('input', {
	          type: 'email',
	          placeholder: localization('global.email'),
	          className: 'input email',
	          name: 'MERGE0' }),
	        uField,
	        idField,
	        !layout ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('textarea', {
	            className: 'textarea',
	            placeholder: localization('global.partnersFormPlaceholder'),
	            name: 'message' })
	        ) : null,
	        _react2.default.createElement(
	          'button',
	          { className: 'btn primary btn-submit', type: 'submit' },
	          localization('global.submit')
	        )
	      )
	    );
	  };
	
	  return SubmitForm;
	}(_react2.default.Component);
	
	exports.default = SubmitForm;
	module.exports = exports['default'];

/***/ }),

/***/ 67:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(22);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	__webpack_require__(126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Timeline = function Timeline(_ref) {
	  var content = _ref.content,
	      lang = _ref.lang,
	      localization = _ref.localization;
	
	  if (content && content.xTimeline && content.yTimeline) {
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'timeline-container' },
	      content.heading ? _react2.default.createElement(
	        'h3',
	        null,
	        content.heading
	      ) : null,
	      _react2.default.createElement(_gatsbyImage2.default, { className: 'timeline-img horizontal', sizes: content.xTimeline.sizes }),
	      _react2.default.createElement(_gatsbyImage2.default, { className: 'timeline-img vertical', sizes: content.yTimeline.sizes })
	    );
	  } else {
	    return null;
	  }
	};
	
	exports.default = Timeline;
	module.exports = exports['default'];

/***/ }),

/***/ 126:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cta = __webpack_require__(13);
	
	var _cta2 = _interopRequireDefault(_cta);
	
	var _markdown = __webpack_require__(8);
	
	var _markdown2 = _interopRequireDefault(_markdown);
	
	__webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VerticalGrid = function (_React$Component) {
	  _inherits(VerticalGrid, _React$Component);
	
	  function VerticalGrid() {
	    _classCallCheck(this, VerticalGrid);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  VerticalGrid.prototype.renderGridItems = function renderGridItems(gridItems) {
	    var _this2 = this;
	
	    if (gridItems) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'vgrid-container' },
	        gridItems.map(function (item, i) {
	          var bgColor = item.backgroundColor ? { backgroundColor: item.backgroundColor } : {};
	          return _react2.default.createElement(
	            'div',
	            { className: 'grid-item', key: i, style: bgColor },
	            _this2.renderItem(item)
	          );
	        })
	      );
	    } else {
	      return null;
	    }
	  };
	
	  VerticalGrid.prototype.renderItem = function renderItem(item) {
	    if (item) {
	
	      var ctas = item.ctaButtons ? item.ctaButtons.map(function (cta, i) {
	        var url = cta.url;
	        var style = cta.style;
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'button-container', key: i },
	          _react2.default.createElement(_cta2.default, { title: cta.title, url: url, style: style })
	        );
	      }) : [];
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          item.heading
	        ),
	        item.body && item.body.body ? _react2.default.createElement(
	          'div',
	          { className: 'grid-item-body' },
	          _react2.default.createElement(_markdown2.default, { content: item.body.body })
	        ) : null,
	        ctas.length > 0 ? _react2.default.createElement(
	          'div',
	          { className: 'button-container' },
	          ctas
	        ) : null
	      );
	    }
	  };
	
	  VerticalGrid.prototype.render = function render() {
	    var gridItems = this.props.content.gridItems;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'grid-wrapper' },
	      this.renderGridItems(gridItems)
	    );
	  };
	
	  return VerticalGrid;
	}(_react2.default.Component);
	
	exports.default = VerticalGrid;
	module.exports = exports['default'];

/***/ }),

/***/ 127:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _util = __webpack_require__(14);
	
	var _closeIcon = __webpack_require__(43);
	
	var _closeIcon2 = _interopRequireDefault(_closeIcon);
	
	__webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var YoutubePlayer = function (_React$Component) {
	  _inherits(YoutubePlayer, _React$Component);
	
	  function YoutubePlayer(props) {
	    _classCallCheck(this, YoutubePlayer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onClose = _this.onClose.bind(_this);
	    _this.state = {
	      play: false
	    };
	    return _this;
	  }
	
	  YoutubePlayer.prototype.getVideoUrl = function getVideoUrl(url) {
	    var params = (0, _util.parseUrlParameters)(url);
	
	    if ('v' in params) {
	      var videoId = params.v;
	
	      return 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&modestbranding=1&controls=1&fs=1';
	    } else {
	      return null;
	    }
	  };
	
	  YoutubePlayer.prototype.onClose = function onClose() {
	    this.props.closeVideo();
	  };
	
	  YoutubePlayer.prototype.render = function render() {
	    var _props = this.props,
	        url = _props.url,
	        height = _props.height,
	        play = _props.play,
	        localization = _props.localization;
	
	    var embedUrl = this.getVideoUrl(url);
	
	    if (play && embedUrl) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'video-container' },
	        _react2.default.createElement('iframe', { width: '100%', height: height, src: embedUrl, allowFullScreen: true }),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn primary close', onClick: this.onClose },
	          _react2.default.createElement(
	            'span',
	            { className: 'description' },
	            localization('global.close')
	          ),
	          _react2.default.createElement(_closeIcon2.default, { className: 'close-icon' })
	        )
	      );
	    } else {
	      return null;
	    }
	  };
	
	  return YoutubePlayer;
	}(_react2.default.Component);
	
	exports.default = YoutubePlayer;
	module.exports = exports['default'];

/***/ }),

/***/ 128:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.convertComponents = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _accordion = __webpack_require__(72);
	
	var _accordion2 = _interopRequireDefault(_accordion);
	
	var _banner = __webpack_require__(94);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _quote = __webpack_require__(102);
	
	var _quote2 = _interopRequireDefault(_quote);
	
	var _contentBlock = __webpack_require__(96);
	
	var _contentBlock2 = _interopRequireDefault(_contentBlock);
	
	var _skillsList = __webpack_require__(103);
	
	var _skillsList2 = _interopRequireDefault(_skillsList);
	
	var _story = __webpack_require__(104);
	
	var _story2 = _interopRequireDefault(_story);
	
	var _imageCarousel = __webpack_require__(100);
	
	var _imageCarousel2 = _interopRequireDefault(_imageCarousel);
	
	var _dualBox = __webpack_require__(98);
	
	var _dualBox2 = _interopRequireDefault(_dualBox);
	
	var _contentGrid = __webpack_require__(97);
	
	var _contentGrid2 = _interopRequireDefault(_contentGrid);
	
	var _verticalGrid = __webpack_require__(105);
	
	var _verticalGrid2 = _interopRequireDefault(_verticalGrid);
	
	var _logoGrid = __webpack_require__(44);
	
	var _logoGrid2 = _interopRequireDefault(_logoGrid);
	
	var _timeline = __webpack_require__(45);
	
	var _timeline2 = _interopRequireDefault(_timeline);
	
	var _newsList = __webpack_require__(101);
	
	var _newsList2 = _interopRequireDefault(_newsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var convertComponents = exports.convertComponents = function convertComponents(_ref) {
	  var components = _ref.components,
	      lang = _ref.lang,
	      news = _ref.news,
	      localization = _ref.localization;
	
	  var renderedComponents = components.map(function (content, index) {
	    var key = content.__typename + '-' + index;
	
	    if (content.__typename == 'ContentfulAccordion') {
	      return _react2.default.createElement(_accordion2.default, { key: key, content: content, lang: lang });
	    } else if (content.__typename == 'ContentfulQuote') {
	      return _react2.default.createElement(_quote2.default, { key: key, content: content, lang: lang });
	    } else if (content.__typename == 'ContentfulContentBlock') {
	      return _react2.default.createElement(_contentBlock2.default, { key: key, content: content, lang: lang });
	    } else if (content.__typename == 'ContentfulSkillsList') {
	      return _react2.default.createElement(_skillsList2.default, { key: key, content: content, lang: lang });
	    } else if (content.__typename == 'ContentfulBanner') {
	      return _react2.default.createElement(_banner2.default, { key: key, content: content, lang: lang, localization: localization });
	    } else if (content.__typename == 'ContentfulNewsList') {
	      return _react2.default.createElement(_newsList2.default, { key: key, content: content, news: news, lang: lang });
	    } else if (content.__typename == 'ContentfulStory') {
	      return _react2.default.createElement(_story2.default, { key: key, content: content, lang: lang });
	    } else if (content.__typename == 'ContentfulImageCarousel') {
	      return _react2.default.createElement(_imageCarousel2.default, { key: key, content: content, lang: lang });
	    } else if (content.__typename == 'ContentfulDualBox') {
	      return _react2.default.createElement(_dualBox2.default, { key: key, content: content, lang: lang });
	    } else if (content.__typename == 'ContentfulContentGrid') {
	      return _react2.default.createElement(_contentGrid2.default, { key: key, content: content, lang: lang });
	    } else if (content.__typename == 'ContentfulVerticalGrid') {
	      return _react2.default.createElement(_verticalGrid2.default, { key: key, content: content, lang: lang });
	    } else if (content.__typename == 'ContentfulLogoGrid') {
	      return _react2.default.createElement(_logoGrid2.default, { key: key, content: content, lang: lang });
	    } else if (content.__typename == 'ContentfulTimeline') {
	      return _react2.default.createElement(_timeline2.default, { key: key, content: content, lang: lang });
	    } else {
	      return null;
	    }
	  });
	
	  return renderedComponents;
	};

/***/ }),

/***/ 73:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var heroFragment = exports.heroFragment = "** extracted graphql fragment **";
	
	var pageContentFragment = exports.pageContentFragment = "** extracted graphql fragment **";

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.indexQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _subpage = __webpack_require__(166);
	
	var _subpage2 = _interopRequireDefault(_subpage);
	
	__webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  IndexPage.prototype.render = function render() {
	    var filteredNews = this.props.data.news.edges.filter(function (edge) {
	      var node = edge.node;
	      return node.heading && node.body && node.body.body;
	    }).splice(0, 3);
	
	    return _react2.default.createElement(_subpage2.default, { data: this.props.data.home, localization: this.props.data.globalLocalization, news: filteredNews });
	  };
	
	  return IndexPage;
	}(_react2.default.Component);
	
	exports.default = IndexPage;
	var indexQuery = exports.indexQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _heroHome = __webpack_require__(165);
	
	var _heroHome2 = _interopRequireDefault(_heroHome);
	
	var _heroSub = __webpack_require__(99);
	
	var _heroSub2 = _interopRequireDefault(_heroSub);
	
	var _factory = __webpack_require__(107);
	
	var _localization = __webpack_require__(46);
	
	__webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubPage = function (_React$Component) {
	  _inherits(SubPage, _React$Component);
	
	  function SubPage() {
	    _classCallCheck(this, SubPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SubPage.prototype.renderHero = function renderHero(page, localization, lang) {
	    if (!page.hero) {
	      return null;
	    }
	
	    return page.title.toLowerCase() === 'home' ? _react2.default.createElement(_heroHome2.default, { content: page.hero, lang: lang, localization: localization }) : _react2.default.createElement(_heroSub2.default, { content: page.hero, lang: lang, localization: localization });
	  };
	
	  SubPage.prototype.render = function render() {
	    var page = this.props.data.contentfulPage || this.props.data;
	    var locale = page.node_locale;
	    var localization = (0, _localization.getLocalization)(this.props.data.globalLocalization || this.props.localization, locale);
	    var lang = locale.substring(0, 2);
	
	    if (!page.content) {
	      return null;
	    }
	
	    var components = (0, _factory.convertComponents)({ components: page.content, lang: lang, localization: localization, news: this.props.news });
	    var header = this.renderHero(page, localization, lang);
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'subpage-container', 'data-cy': 'subpage' },
	      header,
	      components
	    );
	  };
	
	  return SubPage;
	}(_react2.default.Component);
	
	exports.default = SubPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-en-js-494777f1542b11e42b06.js